export default function Hero() {
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) {
      const top = el.getBoundingClientRect().top + window.pageYOffset - 80;
      window.scrollTo({ top, behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="relative w-full min-h-[580px] md:min-h-[640px] flex items-center overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-primary-50 via-background-50 to-accent-50"></div>
      <div className="absolute top-0 right-0 w-[60%] h-full opacity-[0.07]">
        <div className="absolute top-10 right-10 w-72 h-72 rounded-full bg-primary-500 blur-3xl"></div>
        <div className="absolute bottom-20 right-40 w-96 h-96 rounded-full bg-accent-500 blur-3xl"></div>
      </div>

      <div className="relative z-10 w-full max-w-[1280px] mx-auto px-4 md:px-6 py-16 md:py-20">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-2 mb-4">
              <span className="px-3 py-1 text-xs bg-primary-100 text-primary-700 rounded-full whitespace-nowrap">热门吃瓜</span>
              <span className="px-3 py-1 text-xs bg-accent-100 text-accent-800 rounded-full whitespace-nowrap">每日更新</span>
              <span className="px-3 py-1 text-xs bg-secondary-100 text-secondary-700 rounded-full whitespace-nowrap">多端同步</span>
            </div>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading text-foreground-900 leading-tight mb-3">
              51吃瓜最新网址
              <span className="block text-2xl md:text-3xl lg:text-3xl text-primary-500 mt-1">
                吃瓜视频一网打尽
              </span>
            </h1>

            <p className="text-base md:text-lg text-foreground-400 mb-2">
              随时随地，想吃就吃
            </p>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-8 max-w-xl mx-auto lg:mx-0">
              51吃瓜最新网址是一个专注于娱乐八卦、明星动态和热门话题的综合资讯平台。我们每天24小时不间断追踪全网最热吃瓜内容，涵盖明星恋情、综艺节目、影视资讯、网红动态等多个板块，为吃瓜爱好者提供最新、最全、最快的吃瓜体验。支持手机版、安卓iOS轻量版APP，随时随地在线观看吃瓜视频，不错过任何一个热搜话题。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6 mb-8">
              <div className="flex items-center gap-2">
                <span className="w-8 h-8 rounded-full bg-primary-100/70 flex items-center justify-center">
                  <i className="ri-flashlight-line text-primary-500 text-sm"></i>
                </span>
                <span className="text-sm text-foreground-600 whitespace-nowrap">日均更新 <strong className="text-primary-500">200+</strong> 条资讯</span>
              </div>
              <div className="flex items-center gap-2">
                <span className="w-8 h-8 rounded-full bg-accent-100/70 flex items-center justify-center">
                  <i className="ri-stack-line text-accent-600 text-sm"></i>
                </span>
                <span className="text-sm text-foreground-600 whitespace-nowrap">覆盖 <strong className="text-accent-600">8大</strong> 内容板块</span>
              </div>
              <div className="flex items-center gap-2">
                <span className="w-8 h-8 rounded-full bg-secondary-100/70 flex items-center justify-center">
                  <i className="ri-user-smile-line text-secondary-500 text-sm"></i>
                </span>
                <span className="text-sm text-foreground-600 whitespace-nowrap"><strong className="text-secondary-600">千万</strong> 瓜友的选择</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#topics"
                onClick={(e) => handleNavClick(e, '#topics')}
                className="w-full sm:w-auto px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 text-sm rounded-md transition-colors duration-200 whitespace-nowrap text-center cursor-pointer"
              >
                立即浏览热门吃瓜
              </a>
              <a
                href="#app"
                onClick={(e) => handleNavClick(e, '#app')}
                className="w-full sm:w-auto px-8 py-3 bg-background-50 hover:bg-background-100 text-foreground-700 text-sm rounded-md border border-background-300 transition-colors duration-200 whitespace-nowrap text-center cursor-pointer"
              >
                下载轻量版APP
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-lg lg:max-w-none">
            <div className="relative aspect-[4/3] lg:aspect-[5/4] w-full overflow-hidden rounded-lg bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=Artistic%20abstract%20modern%20composition%20with%20warm%20coral%20and%20amber%20tones%2C%20flowing%20organic%20shapes%20representing%20entertainment%20news%20and%20information%20streams%2C%20contemporary%20editorial%20design%20with%20soft%20gradients%2C%20dynamic%20layered%20textures%20suggesting%20movement%20and%20energy%2C%20sophisticated%20aesthetic%20for%20media%20platform%2C%20warm%20inviting%20atmosphere%2C%20minimal%20geometric%20elements%2C%20cinematic%20quality&width=1200&height=960&seq=hero-main&orientation=landscape"
                alt="51吃瓜最新网址 - 娱乐八卦资讯聚合平台主视觉"
                title="51吃瓜最新网址 - 吃瓜视频一网打尽"
                className="w-full h-full object-cover object-top rounded-lg"
              />
              <div className="absolute inset-0 bg-gradient-to-tr from-primary-500/10 to-transparent rounded-lg"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}